import script from "./TabNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TabNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TabNavigation.vue?vue&type=style&index=0&id=3f4b9644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4b9644"]])

export default __exports__